<template>
  <div id="dashboard-settings">
    <div v-if="!isLoading">
      <mu-card-header
        class="dashedItem"
        titleClass="boldTitle largeTitle"
        :title="title"
        :subTitle="subTitle"
      ></mu-card-header>
      <mu-list>
        <draggable v-model="order" :options="{draggable:'.item', handle: '.handle'}">
          <mu-list-item
            v-for="item, index in order"
            :key="'card-order-' + index"
            class="item dashboardItem dashedItem"
            :title="$t(getNameByKey(item.name))"
            v-bind:class="{'odd': index % 2 === 0}"
            disableRipple
          >
            <mu-checkbox
              class="greenIcon"
              v-model="item.hidden"
              slot="left"
              uncheckIcon="radio_button_checked"
              checkedIcon="radio_button_unchecked"
            />
            <mu-icon
              class="handle"
              slot="after"
              value="menu"
            ></mu-icon>
          </mu-list-item>
        </draggable>
      </mu-list>
      <mu-card-text>
        <mu-raised-button
          class="large"
          v-if="order.length > 0"
          :disabled="isUpdating"
          @click.native="submitForm()"
          :label="!isUpdating ? $t('message.updateText') : $t('message.updatingText')"
          fullWidth
          secondary
        ></mu-raised-button>
      </mu-card-text>
    </div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>
  import SettingsApi from '../../api/Settings'
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable
    },
    data() {
      return {
        title: this.$t('message.dashboardPreferencesTitle'),
        subTitle: this.$t('message.dashboardPreferencesSubTitle'),
        isUpdating: false,
        isLoading: true,
        order: []
      }
    },
    mounted() {
      let self = this;
      if (self.$store.state.cardOrder.length > 0) {
        self.order = self.$store.state.cardOrder;
        self.isLoading = false;
      }
      else {
        SettingsApi.getCardOrder()
          .then(function (response) {
            self.order = response.data;
            self.$store.commit('setCardOrder', response.data);
            self.isLoading = false;
          })
      }
    },
    methods: {
      getNameByKey(key) {
        switch (key) {
          case "ACTIVITY":
            return "message.cardActivity";
          case "WEIGHT":
            return "message.cardWeight";
          case "BLOOD_GLUCOSE":
            return "message.cardBloodGlucose";
          case "SLEEP":
            return "message.cardSleep";
          case "CHOLESTEROL":
            return "message.cardCholesterol";
          case "MEDICATION":
            return "message.cardMedication";
          case "BLOOD_PRESSURE":
            return "message.cardBloodPressure";
          case "MOOD":
            return "message.cardMood";
          case "KETONES":
            return "message.cardKetones";
          case "NUTRITION":
            return "message.cardNutrition";
          case "INSULIN":
            return "message.cardInsulin";
        }
      },
      submitForm() {
        let self = this;
        self.isUpdating = true;
        self.$store.commit('setCardOrder', self.order);
        SettingsApi.updateCardOrder(self.order)
          .then(function (response) {
            self.isUpdating = false;
            self.$toastr.success("Updated card order");
            self.$router.push({
              name: 'Dashboard'
            })
          })
      }
    }
  }
</script>
<style lang="less">
  #dashboard-settings {
    .mu-list {
      padding-top: 0;
      padding-bottom: 0;
    }
    .handle {
      cursor: move;
      color: #1799FF;
    }
    .mu-item.show-left {
      padding-left: 54px !important;
    }
    .greenIcon {
      .mu-checkbox-icon-checked {
        color: #90C338 !important;
      }
      .mu-checkbox-icon-uncheck {
        color: #90C338 !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?28ab4906